import { StringKey } from '../lang/index';
import { StakeholderRole, StakeholderType, StakeholderTypeGroup } from '../types/stakeholder.types';

export const stakeholderRoleTranslation: Record<StakeholderRole, StringKey> = {
  [StakeholderRole.ADMIN]: 'ADMIN',
  [StakeholderRole.CONTRIBUTOR]: 'CONTRIBUTOR',
  [StakeholderRole.STAKEHOLDER]: 'STAKEHOLDER',
};

export const stakeholderTypeTranslation: Record<StakeholderType, StringKey> = {
  [StakeholderType.ADVISOR]: 'ADVISOR',
  [StakeholderType.ANGEL]: 'ANGEL',
  [StakeholderType.EMPLOYEE]: 'EMPLOYEE',
  [StakeholderType.FOUNDER]: 'FOUNDER',
  [StakeholderType.BOARD_MEMBERS]: 'BOARD_MEMBER',
  [StakeholderType.VCS]: 'VCS',
  [StakeholderType.INVESTMENT_BANKS]: 'INVESTMENT_BANK',
  [StakeholderType.PES]: 'PES',
  [StakeholderType.FAMILY_OFFICE]: 'FAMILY_OFFICE',
  [StakeholderType.SPV]: 'SPV',
  [StakeholderType.OTHER_INST]: 'OTHER_INST',
};

export const arrayOfStakeholderTypeTranslation = Object.entries(stakeholderTypeTranslation);

export const stakeholderTypeGroupTranslation: Record<StakeholderTypeGroup, StringKey> = {
  [StakeholderTypeGroup.COMPANY]: 'STAKEHOLDER_COMPANY_GROUP',
  [StakeholderTypeGroup.HUMAN]: 'STAKEHOLDER_HUMAN_GROUP',
};

export const arrayOfStakeholderTypeGroupTranslation = Object.entries(
  stakeholderTypeGroupTranslation,
);
